import {DayOfWeek, NotificationInterval, NotificationMediaType, NotificationType} from "@/models/Enums";

export default class BaseNotificationSetting {

    public notificationType: NotificationType = NotificationType.WorkOrdersProcessedApproval;

    public mediaType: NotificationMediaType = NotificationMediaType.Email;

    public interval: NotificationInterval = NotificationInterval.OnDemand;

    public enabled: boolean = false;

    public pausedFrom: Date | null = null;

    public pausedUntil: Date | null = null;

    public sendTime: Date = new Date();

    public weeklySendOccurrence: DayOfWeek[] = [];

    public isBaseNotificationSetting: boolean = true;
}